module.exports = "/_next/static/images/demo-ribbon-pattern-9559ed7846481bf871ea4262466b1a13.svg";